import { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
// project import
import Loadable from 'components/Loadable';
import StockUpload from 'pages/stock_management/stockupload';
import SalesOrderUpload from 'pages/Sales Order/salesOrderUpload';
import { Navigate } from 'react-router-dom';
import Barcodassessment from 'pages/Sales Order/Barcodsoassessment';
import DivisionOutStanding from 'pages/Reports/DivisionOutStanding';
import LedgerPreviousYear from 'pages/Reports/LedgerPreviousYear';
import LedgerPreviousYearDetails from 'pages/Reports/LedgerPreviousYearDetails';
import VendorLedger from 'pages/Reports/VendorLedger';
import VendorLedgerDetails from 'pages/Reports/VendorLedgerDetails';
import Beats from 'pages/Beat/Beats';
import BeatCustomers from 'pages/Beat/BeatCustomers';
import BeatPlanning from 'pages/Beat/BeatPlanning';
import BeatCustomerReports from 'pages/Beat/BeatCustomerReports';
import DistributorReports from 'pages/Reports/DistributorReports';
import MarketIntelligence from 'pages/Beat/MarketIntelligence';
import DivisionOutStandingNew from 'pages/Reports/DivisionOutStandingNew';
// import BeatCustomerReports from 'pages/Beat/BeatCustomerReports';
// import BeatMReport from 'pages/Beat/BeatMReport';
import ProductCatalogue from 'pages/Product Catalogue/ProductCatalogue'
import UserReports from 'pages/Reports/UserReports';
import BarcodeScan from 'pages/SampleRequest/BarcodeScan';
import SampleRequestDashboard from 'pages/SampleRequest/SampleRequestDashboard';
import SampleSelection from 'pages/SampleRequest/SampleSelection';
import BarcodeDesign from 'pages/SampleRequest/BarcodeDesign';
import BarcodeDesign90days from 'pages/sampleRequest90days/BarcodeDesign90days';
import SampleRequest90daysDashboard from 'pages/sampleRequest90days/SampleRequest90daysDashboard';
import BarcodeScan90days from 'pages/sampleRequest90days/BarcodeScan90days';
import SampleSelection90days from 'pages/sampleRequest90days/SampleSelection90days';
import GoodAndReturns from 'pages/GoodAndReturns/GoodAndReturns';
import GoodAndReturnsTransfer from 'pages/GoodAndReturns/GoodAndReturnsTransfer';
import UserReports2 from 'pages/Reports/UserReports/index';
import PendingOrderReports from 'pages/Reports/PendingOrderReports';
import OutstandingReports from 'pages/Reports/OutstandingReports';
import CollectionReceived from 'pages/Reports/CollectionReceived';
import CombinedReportsUI from 'pages/Reports/CombinedReports';
import SchemeReport from 'pages/Reports/SchemeReport';
import GoodAndReturnsList from 'pages/GoodAndReturns/GoodAndReturnsList';
import ReportsDashboard from 'pages/Reports/ReportsDashboard';
import NotFound from 'pages/Auth/404';
import CollectionTargetAchvReport from 'pages/Reports/CollectionTargetAchvReport';
import CurrentMonthsSalesReport from "pages/Reports/CurrentMonthsSalesReport";

const Orders = Loadable(lazy(() => import('pages/Sales Order/Orders')));
const SampleCheck = Loadable(lazy(() => import('pages/sample_check/samplecheck')));
const SampleCheckFabric = Loadable(lazy(() => import('pages/sample_check/samplecheckfabric')));
const Barcodso = Loadable(lazy(() => import('pages/Sales Order/Barcodso')));
const Barcodsog = Loadable(lazy(() => import('pages/Sales Order/Barcodsog')));
const Stockselectionf = Loadable(lazy(() => import('pages/Sales Order/Stockselectionf')));
const SFAStockselectionf = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/Stockselectionf')));
const Stockselectiong = Loadable(lazy(() => import('pages/Sales Order/Stockselectiong')));
const ProductBookingf = Loadable(lazy(() => import('pages/Sales Order/ProductBookingf')));
const FabricProductBookingf = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/ProductBookingf')));
const ProductBookingg = Loadable(lazy(() => import('pages/Sales Order/ProductBookingg')));
const DeliverySchedulef = Loadable(lazy(() => import('pages/Sales Order/DeliverySchedulef')));
const SFADeliverySchedulef = Loadable(lazy(() => import('pages/Sales Order/FabricOrder/DeliverySchedulef')));
const DeliveryScheduleg = Loadable(lazy(() => import('pages/Sales Order/DeliveryScheduleg')));
const OrderDetails = Loadable(lazy(() => import('pages/Sales Order/OrderDetails')));
const OrderDetailsf = Loadable(lazy(() => import('pages/Sales Order/OrderDetailsf')));
const DeliveryConfirmation = Loadable(lazy(() => import('pages/Sales Order/DeliveryConfirmation')));
const Dashboad = Loadable(lazy(() => import('pages/Sales Order/Dashboad.js')));
const Auth = Loadable(lazy(() => import('pages/Auth/Auth')));
const BarcodeDashboard = Loadable(lazy(() => import('pages/Sales Order/BarcodeDashboard')));
const AttedanceReport = Loadable(lazy(() => import('pages/Reports/AttedanceReport.js')));
const MyOrdersReport = Loadable(lazy(() => import('pages/Reports/MyOrdersReport.js')));
const LedgerReport = Loadable(lazy(() => import('utils/LedgerReport')));
const SeorReport = Loadable(lazy(() => import('utils/seoreport')));
const StockDownload = Loadable(lazy(() => import('pages/Downloads/StockDownload.js')));

const CustomerProfile = Loadable(lazy(() => import('pages/Customer Profile/CustomerProfile.js')));
const LedgerCurrentYear = Loadable(lazy(() => import('pages/Reports/LedgerCurrentYear.js')));
const LedgerDiv = Loadable(lazy(() => import('pages/Reports/LedgerDiv.js')));
const LedgerCurrentYearDetails = Loadable(lazy(() => import('pages/Reports/LedgerCurrentYearDetails.js')));
const LedgerDivDetails = Loadable(lazy(() => import('pages/Reports/LedgerDivDetails.js')));
const PtFileController = Loadable(lazy(() => import('pages/Downloads/PtFile.js')));
const AssessmentReports = Loadable(lazy(() => import('pages/Reports/AssessmentReports.js')));

//const ProductCatalogue = Loadable(lazy(() => import('pages/Product Catalogue/ProductCatalogue.js')));
// ==============================|| MAIN ROUTING ||============================== //
const isAuthenticated = localStorage.getItem('authenticated') === 'true';
const MainRoutes = {
  path: '/',
  element: isAuthenticated ? <MainLayout /> : <Auth />,
  children: [
    {
      path: '/',
      element: <Navigate to={isAuthenticated ? '/report-dashboard' : '/auth'} replace />
    },
    {
      path: '/salesorder',
      element: <Orders />
    },
    {
      path: '/dashboard',
      element: <Dashboad />
    },
    {
      path: '/barcodeSO',
      element: <Barcodso />
    },
    {
      path: '/barcodeSOg',
      element: <Barcodsog />
    },
    {
      path: '/stockselectionf',
      element: <Stockselectionf />
    },
    {
      path: '/sfa-stockselectionf',
      element: <SFAStockselectionf />
    },
    {
      path: '/stockselectiong',
      element: <Stockselectiong />
    },
    {
      path: '/productBookingf',
      element: <ProductBookingf />
    },
    {
      path: '/sfa-productBookingf',
      element: <FabricProductBookingf />
    },
    {
      path: '/productBookingg',
      element: <ProductBookingg />
    },
    {
      path: '/deliveryschedulef',
      element: <DeliverySchedulef />
    },
    {
      path: '/sfa-deliveryschedulef',
      element: <SFADeliverySchedulef />
    },
    {
      path: '/deliveryscheduleg',
      element: <DeliveryScheduleg />
    },
    {
      path: '/saleorderdetails',
      element: <OrderDetails />
    },
    {
      path: '/saleorderdetailsf',
      element: <OrderDetailsf />
    },
    {
      path: '/deliveryconfirmation',
      element: <DeliveryConfirmation />
    },
    {
      path: '/barcodedashboard',
      element: <BarcodeDashboard />
    },
    {
      path: '/barcodedashboard',
      element: <BarcodeDashboard />
    },
    {
      path: '/attedancereport',
      element: <AttedanceReport />
    },
    {
      path: '/myordersreport',
      element: <MyOrdersReport />
    },
    {
      path: '/customerProfile',
      element: <CustomerProfile />
    },
    {
      path: '/samplecheck',
      element: <SampleCheck />
    },
    {
      path: '/samplecheckf',
      element: <SampleCheckFabric />
    },
    {
      path: '/ledger',
      element: <LedgerReport />
    },
    {
      path: '/seoreport',
      element: <SeorReport />
    },
    {
      path: '/stockdownload',
      element: <StockDownload />
    },
    {
      path: '/stockupload',
      element: <StockUpload />
    },
    {
      path: '/salesOrderUpload',
      element: <SalesOrderUpload />
    },
    {
      path: '/ledgerCurrentYear',
      element: <LedgerCurrentYear />
    },
    {
      path: '/ledgerDiv',
      element: <LedgerDiv />
    },
    {
      path: '/vendorLedger',
      element: <VendorLedger />
    },
    {
      path: '/vendorledgerDetails',
      element: <VendorLedgerDetails />
    },
    {
      path: '/ledgerCurrentYearDetails',
      element: <LedgerCurrentYearDetails />
    },
    {
      path: '/ledgerPreviousYearDetails',
      element: <LedgerPreviousYearDetails />
    },
    {
      path: '/ledgerDivDetails',
      element: <LedgerDivDetails />
    },
    {
      path: '/ledgerPreviousYear',
      element: <LedgerPreviousYear />
    },
    {
      path: '/ptFile',
      element: <PtFileController />
    },
    {
      path: '/passessment',
      element: <Barcodassessment />
    },
    {
      path: '/divoutstanding',
      element: <DivisionOutStanding />
    },
    {
      path: '/divoutstandingnew',
      element: <DivisionOutStandingNew />
    },
    {
      path: '/assessment-reports',
      element: <AssessmentReports />
    },
    {
      path: '/beats',
      element: <Beats />
    },
    {
      path: '/beat-customers',
      element: <BeatCustomers />
    },
    {
      path: '/beat-planning',
      element: <BeatPlanning />
    },
    {
      path: '/beat-customer-reports',
      element: <BeatCustomerReports />
    },
    {
      path: '/distributorkpi-reports',
      element: <DistributorReports />
    },
    {
      path: '/market-intelligence',
      element: <MarketIntelligence />
    },
    // {
    //   path: '/beat-m-report',
    //   element: <BeatMReport />
    // },
    {
      path: '/product-catalogue',
      element: <ProductCatalogue />
    },
    {
      path: '/user-reports',
      element: <UserReports />
    },
    {
      path: '/sample-request-barcode-scan',
      element: <BarcodeScan />
    },
    {
      path: '/sample-request-dashboard',
      element: <SampleRequestDashboard />
    },
    {
      path: '/sample-request-selection',
      element: <SampleSelection />
    },
    {
      path: '/sample-design',
      element: <BarcodeDesign />
    },
    {
      path: '/good-returns-list',
      element: <GoodAndReturnsList />
    },
    {
      path: '/good-returns',
      element: <GoodAndReturns />
    },
    {
      path: '/good-returns-transfer',
      element: <GoodAndReturnsTransfer />
    },
    {
      path: '/sample-design-sales-planning',
      element: <BarcodeDesign90days />
    },
    {
      path: '/dashboard-sales-planning',
      element: <SampleRequest90daysDashboard />
    },
    {
      path: '/barcode-scan-sales-planning',
      element: <BarcodeScan90days />
    },
    {
      path: '/sample-selection-sales-planning',
      element: <SampleSelection90days />
    },
    {
      path: '/user-reports-2',
      element: <UserReports2 />
    },
    {
      path: '/pending-order-reports',
      element: <PendingOrderReports />
    },
    {
      path: '/outstanding-reports',
      element: <OutstandingReports />
    },
    {
      path: '/collection-recieved',
      element: <CollectionReceived />
    },
    {
      path: '/CombinedReportsUI',
      element: <CombinedReportsUI />
    },
    {
      path: '/scheme-report',
      element: <SchemeReport />
    },
    {
      path: '/report-dashboard',
      element: <ReportsDashboard />
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />
    },
    {
      path: '/404',
      element: <NotFound />
    },
    {
      path: '/collection-target-achv-report',
      element: <CollectionTargetAchvReport />
    },
    {
      path: '/current-month-sales-report',
      element: <CurrentMonthsSalesReport />
    }
  ]
};

export default MainRoutes;
